function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 12L1.11662 11.9933C1.5757 11.9399 1.93995 11.5757 1.99327 11.1166L2 11V2H11L11.1166 1.99327C11.614 1.93551 12 1.51284 12 1C12 0.487164 11.614 0.0644928 11.1166 0.00672773L11 0H1L0.883379 0.00672773C0.424297 0.0600494 0.0600494 0.424297 0.00672773 0.883379L0 1V11L0.00672773 11.1166C0.0600494 11.5757 0.424297 11.9399 0.883379 11.9933L1 12ZM15 16L15.1166 15.9933C15.5757 15.9399 15.9399 15.5757 15.9933 15.1166L16 15V5L15.9933 4.88338C15.9444 4.46255 15.6343 4.12142 15.2293 4.02641L15.1166 4.00673L15 4H5L4.88338 4.00673C4.4243 4.06005 4.06005 4.4243 4.00673 4.88338L4 5V15L4.00673 15.1166C4.05561 15.5374 4.36575 15.8786 4.77071 15.9736L4.88338 15.9933L5 16H15ZM6 6V14H14V6H6Z",
  fill: "#353F50"
});

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.151ef331.svg";
export { ForwardRef as ReactComponent };